define(function (require) {
	const tpl = require('./t_lov_authentication.hbs');
	const ccn = require('../../core_constants');
	const view_manager = require('civicsUtils/view_manager');
	const modal_region = require('civicsUtils/modal_region');
	const responseUtils = require('../2fa_response_utils');
	const twoFactorUtility = require('../2fa_utility');
	const Utils = require('civicsUtils/general_utilities');
	const LoginModel = require('civicsModels/login_model');

	return Marionette.LayoutView.extend({
		className:'v-lov-factor-authentication-code-modal',
		template: tpl,
		regions: {
			modalRegion: {
				regionClass: modal_region,
				selector: 'body .rhythm-modals'
			},
			confirmationRegion: {
				selector: '.confirmation-modal-container', // Add a sub-region
			}
		},
		ui:{
			closeModalButton:'.close-modal',
			closeModalXButton:'.bbm-btn-close',
			submitButton:'.submit-code',
			authenticationCodeField:'.authentication-code',
			resendCodeLink:'.resend-code-link',
			confirmationModalContaienr: '.confirmation-modal-container',
			tryAnotherMethodLink: '.try-another-method-link'
		},
		events: {
			'click @ui.closeModalButton':'closeModal',
			'click @ui.closeModalXButton':'closeModal',
			'click @ui.submitButton':'submitClicked',
			'click @ui.resendCodeLink':'resendCodeClicked',
			'click @ui.tryAnotherMethodLink':'tryAnotherMethod'
		},
		initialize: function (options) {
			this.options = options;
			this.config = options.config || {};
			this.config.globalConfig = view_manager.globalConfig().toJSON();
			if( options.originalModel == null ||//no model to use included
				options.mfaToken == null)//no token received
			{
				console.log('No model or no token received.')
				return;
			}
			//we need to know if we are verifying a new subscription, or authenticating. 
			//This will impact failure and messaging.
			this.isAuthentication = options.codeType === ccn.AUTHENTICATION;
			this.isVerification = options.codeType === ccn.VERIFICATION;
		},
		onShow: function () {
			this.ui.authenticationCodeField.focus();
			this.ui.authenticationCodeField.on('keyup', (e)=> {
				if (e.key === 'Enter' || e.keyCode === 13) {
					this.submitClicked();
				}
			});
		},
		closeModal:function(e){
			e.stopPropagation();
			e.stopImmediatePropagation();
			e.preventDefault();
			if (this.config.globalConfig.mfaEnforced && App.localStorage.get('CIVICS', 'REQUIRES_MFA_ENROLLMENT')) {
				// Remove hidden class of this container so we can show the confirmation modal in this.showChildView()
				this.ui.confirmationModalContaienr.removeClass('hidden');

				let twoFactorUtil = twoFactorUtility({ modalRegion: this.getRegion('modalRegion') });
				let confirmCloseMFASetup = twoFactorUtil.showMFASetupSkipConfirmation(this.onConfirmClose.bind(this));
				this.showChildView('confirmationRegion', confirmCloseMFASetup);
			return false;
			} else {
				if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			this.cancelLogin(null);
			this.destroy();
			}
		},
		onConfirmClose:function(e) {
			view_manager.loading(true);
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			// Clean up event listener and flags
			window.removeEventListener('beforeunload', this.beforeUnloadHandler);
			App.sessionStorage.remove('CIVICS', 'MFA_SETUP_ACTIVE');
			App.sessionStorage.remove('CIVICS', 'MFA_RELOAD_LOGOUT');
			
			window.location.href = '/c/portal/logout';
		},
		submitClicked:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.submitButton.prop('disabled',true);
			let code = this.getAuthenticationCode();
			if(code){//if there's no code, the getAuthenticationCode() will have fired a validation error
				this.saveAuthenticationCode(code);
			} else {//validation error, re enable the button so they can try again
				this.ui.submitButton.prop('disabled',false);
			}
		},
		getAuthenticationCode:function(){
			return responseUtils.getAuthenticationCode(this);
		},
		saveAuthenticationCode:function(data){
			//implement new model here.
			let httpPromise = null;
			//so this kinda stinks, destroy takes the options as the first parameter, and save 
			//takes model data as the first parameter, and options as the second parameter. so 
			//we have to branch to make the right call. note the null in the parameters for the save.
			let options = {
				headers:{
					'X-IPS-PortalAuth-Token':this.options.mfaToken,
					'X-IPS-PortalAuth-Claim':data.authenticationCode
				}
			};
			if(this.options.method === ccn.SAVE){
				httpPromise = this.options.originalModel.save(null,options);
			} else if(this.options.method === ccn.DESTROY){
				httpPromise = this.options.originalModel.destroy(options);
			} else {
				//we should never be here.
				console.log('Unknown method called by authentication modal')
				httpPromise = new $.Deferred();
				httpPromise.reject();
			}
			$.when(httpPromise).done((response)=>{
				// need to sync the session data due to changes 
				view_manager.clearUserSpecificSessionStorage(["USER_SESSION"]);
				view_manager.clearUserSpecificLocalStorage();
				this.saveAuthenticationCodeSuccessful();
			}).fail((response)=>{
				this.handleErrorResponse(response);
			});
		},
		saveAuthenticationCodeSuccessful:function(){
			this.options.promptForAuthenticationCodePromise.resolve();
		},
		resendCodeClicked:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			view_manager.loading(true);
			let httpPromise = null;

			if(this.options.method === ccn.SAVE){
				httpPromise = this.options.originalModel.save(null);
			} else if(this.options.method === ccn.DESTROY){
				httpPromise = this.options.originalModel.destroy();
			} else {
				//we should never be here.
				console.log('Unknown method called by resend code')
				httpPromise = new $.Deferred();
				httpPromise.reject();
			}
			$.when(httpPromise).done((response)=>{
				//we should never get here
				console.log('Unknown error when requesting code resend.', response)
			}).fail((response)=>{
				this.updateCode(response)
				
			}).always(()=>{
				view_manager.loading(false);
			});
		},
		updateCode(response){
			let isValidHttpCode = (response.statusCode().status == 403 && this.isVerification) || 
				(response.statusCode().status == 401 && this.isAuthentication);
			let mfaStatus = responseUtils.getReasonFromResponse(response);
			if (isValidHttpCode && mfaStatus == ccn.NOTIFIED)
			{//successfully requested new code
				let parsed = responseUtils.parseResponse(response);
				this.options.mfaToken = parsed.mfaToken;
				Utils.civicsToastPop( i18n.t('CIVICS.LOGIN.FACTOR_AUTH.CODE_RESENT',{details:this.options.factor.details}), "success");
			} else {
				this.handleErrorResponse(response);
			}
		},
		handleErrorResponse:function(response){
			// Check if response contains hasFallbackMethods and update options
			if (response.responseJSON?.data?.hasFallbackMethods) {
				this.options.hasFallbackMethods = true;
				this.render(); // Re-render to show Try Another Method link
			}
			responseUtils.handleErrorResponse(response, this, this.options.codeType);
		},
		tryAnotherMethod:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			const loginModel = new LoginModel();
			loginModel.useFallback = true;
			loginModel.set({
				username: this.options.originalModel.get('username'),
				password: this.options.originalModel.get('password')
			});
			view_manager.loading(true);
			loginModel.save().done((response) => {
				view_manager.loading(false);
				// Trigger new authentication flow with fallback response
				this.options.promptForAuthenticationCodePromise.reject({ 
					tryAnotherMethod: true, 
					fallbackResponse: response 
				});
			}).fail((response) => {
				view_manager.loading(false);
				// Check if this is a 401 with MFA data (expected for fallback)
				if (response.status === 401 && response.responseJSON?.data?.mfaStatus) {
					this.options.promptForAuthenticationCodePromise.reject({ 
						tryAnotherMethod: true, 
						fallbackResponse: response.responseJSON.data 
					});
				} else {
					this.handleErrorResponse(response);
				}
			});
		},
		cancelLogin:function(reason){
			let ret = {
				reason:reason,
				isAuthentication:this.isAuthentication,
				isVerification:this.isVerification
			}
			this.options.promptForAuthenticationCodePromise.reject(ret);
		},
		templateHelpers: function () {
			// const twoFactorUtility = require('../2fa_utility');
			let contactDetails = this.options.factor.details;
			let modalType = this.isVerification ? 'VERIFICATION' : 'AUTHENTICATION';
			let methodType = this.options.methodType || twoFactorUtility().getAuthenticationStrings();
			const hasMultipleMfaMethods = this.options.hasFallbackMethods || false;
			return {
				title:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_TITLE', {methodTypeTitle: methodType.methodTypeTitle}),
				button:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_BUTTON'),
				bodyText:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_BODY_TEXT',
				{details:contactDetails}),
				authenticationPlaceholder:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_PLACEHOLDER',
					{details:contactDetails}),
				label:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_LABEL'),
				newCode:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_REQUEST_NEW_CODE'),
				newCodeLink:i18n.t('CIVICS.LOGIN.FACTOR_AUTH.'+modalType+'_REQUEST_NEW_CODE_LINK'),	
				mfaEnforced: this.config.globalConfig.mfaEnforced,
				hasMultipleMfaMethods: hasMultipleMfaMethods,
				isFallbackMethod: this.options.isFallbackMethod || false
			};
		}
	});
});
